import buildMeta from '@/router/utils/buildMeta'
import {
  userCanAccessPowerEdit,
} from '../guards/powerEdit'

const routes = [
  {
    name: 'poweredit',
    path: '/opportunity/:opportunityId/optimize',
    beforeEnter: [userCanAccessPowerEdit],
    component: () => import('@/pages/PowerEditNew/PowerEdit.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'PowerEdit',
      title: 'PowerEdit - Jobscan',
      liveChatEnabled: true,
    }),
  },
  {
    name: 'poweredit-keyword-testing-tool',
    path: '/poweredit-keyword-testing-tool',
    component: () =>
      import(
        '@/pages/PowerEditNew/components/KeyTestingTool/KeyTestingTool.vue'
      ),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'PowerEdit Testing tool',
      title: 'PowerEdit - Jobscan',
    }),
  },
  {
    name: 'scan-history',
    path: '/scan-history',
    component: () => import('@/pages/PowerEditNew/ScanHistory.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Scan History',
      title: 'Scan History - Jobscan',
    }),
  },
]

export default routes
